import { useState } from 'react';

export const useCopyToClipboard = () => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async (text: string) => {
    try {
      let written = false;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(text);
          written = true;
        } catch {
          // Some Cordova webviews expose this API but reject clipboard writes.
        }
      }
      if (!written) {
        // Keep the established fallback for older webviews, and only report
        // success when the browser actually accepts the copy command.
        const textarea = document.createElement('textarea');
        const previousFocus = document.activeElement;
        textarea.value = text;
        textarea.readOnly = true;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        try {
          textarea.select();
          written = document.execCommand('copy');
        } finally {
          textarea.remove();
          if (previousFocus instanceof HTMLElement) previousFocus.focus({ preventScroll: true });
        }
      }
      if (!written) return false;

      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
      return true;
    } catch (err) {
      console.error('Failed to copy:', err);
      return false;
    }
  };

  return { copyToClipboard, copied };
};
